import dynamic from 'next/dynamic'

export const ProfilePaymentCard = dynamic(
    () => import('./profile-payment-card'),
    {
        ssr: false,
    },
)
